import React from "react";
import { Box, Typography } from "@mui/material";
import commonColorUtils from "../utils/common_colors";

function CommonTextWithRoundedShape({
  text,
  leftMarging = 1,
  horizontalPadding = 5,
  verticalPadding = 10,
  backgroundColor = commonColorUtils.kSecondaryAlert300,
  color = commonColorUtils.kWhiteShade,
  fontSize = "14px",
  fontWeight = 600,
  borderRadius = "8px",
}) {
  return (
    <Box
      sx={{
        ml: leftMarging,
        padding: `${horizontalPadding}px ${verticalPadding}px`,
        backgroundColor,
        color,
        borderRadius,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
          textAlign: "center",
        fontSize,
        fontWeight,
      }}
    >
      {text}
    </Box>
  );
}

export default CommonTextWithRoundedShape;
